/*
Texto livre vai como o usuário digitou; a API trata por base
(mongoQS envolve cada termo em aspas, elasticQS passa ao query_string)
*/
export default (value) => {
  if (!(/\w/.test(value))) { // pelo menos 1 caractere valido
    return null
  }

  return value.replace(/\s+/g, ' ').trim()
}



// WEBPACK FOOTER //
// ./src/utils/KeywordSearchSanitize.js